import { hexToRGB } from '@repo-level/core-front';
import styled from 'styled-components/macro';

export interface UserProfileProps {
  mob?: boolean;
}

export const ScUserPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export const ScUserPanelMobile = styled.div`
  display: flex;
  width: 100%;
  row-gap: 8px;
  flex-direction: column;
`;

export const ScLevel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.whiteColor};
  gap: 8px;

  svg {
    object-fit: contain;
  }

  .divider {
    width: 1px;
    height: 16px;
    background: ${({ theme }) => hexToRGB(theme.whiteColor, 0.2)};
    border-radius: 2px;
    flex-shrink: 0;
  }
`;

export const ScUserProfile = styled.div<UserProfileProps>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 24px 0 0;
  border-top: ${({ theme }) => `1px solid ${hexToRGB(theme.whiteColor, 0.1)}`};
`;

export const ScUserProfileMobile = styled.div<UserProfileProps>`
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 8px;
  background: ${({ theme }) => theme.grayColor6};
  border-radius: 16px;

  & > .info {
    display: flex;
    justify-content: space-between;

    .title {
      font-weight: 700;
      font-size: 14px;
      line-height: 1.43;
      color: ${({ theme }) => theme.grayColor1};
    }
  }
`;
